import React, { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { RescheduleSimulationContent } from "../tasks/Reschedule/RescheduleSimulationContent.jsx";

export const RescheduleAction = ({
  children,
  action,
  getSimulation,
  simulation,
  splitTask,
  onCancel,
  isSimulationChanged,
}) => {
  const { t } = useTranslation();
  const dataRef = useRef();
  const callback = children.props[action];
  const [open, setOpen] = useState(false);

  const handleChange = useCallback(
    (dates) => {
      const { from, to } = dates || {};
      const call = async () => {
        if (typeof getSimulation === "function") {
          const action = await getSimulation(from, to);

          if (action) {
            const { response = {} } = action;
            const { entities = {} } = response;

            if (entities.reschedule_simulation) {
              dataRef.current = dates;
              setOpen(true);
              return;
            }
          }

          setOpen(false);
          callback(dates);
          return;
        }
      };
      call();
    },
    [getSimulation, callback]
  );

  const handleCancel = useCallback(() => {
    setOpen(false);
  }, []);

  const onClose = useCallback(() => {
    handleCancel();
    typeof onCancel === "function" && onCancel();
  }, [handleCancel, onCancel]);

  const handleSubmit = useCallback(() => {
    typeof callback === "function" && callback(dataRef.current);
    onClose();
  }, [callback, onClose]);

  return (
    <>
      {React.cloneElement(children, {
        [action]: handleChange,
      })}
      <Dialog
        open={open}
        className={classNames("", { "tw-w-[90%] tw-max-w-[830px]": simulation.length })}
        onClose={onClose}
      >
        <RescheduleSimulationContent
          simulation={simulation}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          simulationChangedText={
            isSimulationChanged
              ? t("Some of the tasks were changed in the meantime. Please check and confirm the change again.")
              : undefined
          }
          splitTask={splitTask}
        />
      </Dialog>
    </>
  );
};

RescheduleAction.propTypes = {
  children: PropTypes.element.isRequired,
  splitTask: PropTypes.object,
  action: PropTypes.string,
  getSimulation: PropTypes.func,
  onCancel: PropTypes.func,
  simulation: PropTypes.array,
  isSimulationChanged: PropTypes.bool,
};

RescheduleAction.defaultProps = {
  action: "onChange",
  simulation: {},
  isSimulationChanged: false,
};
